import { Card, CircularProgress, Container } from '@mui/material';
import { PATH_DASHBOARD } from 'src/routes/paths';
import { useLocales } from 'src/locales';
import { useSettingsContext } from 'src/components/settings';
import { Helmet } from 'react-helmet-async';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs/CustomBreadcrumbs';
import { setDataGridLocale } from 'src/utils/dataGridLocaleHelper';
import { useSelector } from 'react-redux';
import { DataGridPro, GridColDef, useGridApiRef } from '@mui/x-data-grid-pro';
import {
  selectAllConfigLotWithCosts,
  useGetConfigLotWithCostQuery,
} from '../../redux/slices/configSlice';
import { nullAndUndefinedSafeCentToEuro } from '../../utils/formatNumber';
import { customToolbarMinimal } from '../../utils/dataGridToolbarHelper';

export default function ConfigLotList() {
  const { translate } = useLocales();
  const apiRef = useGridApiRef();
  const { themeStretch } = useSettingsContext();
  const { isSuccess: allConfigLotLoaded, isLoading: isLoadingAllConfigLot } =
    useGetConfigLotWithCostQuery();

  const allConfigLot = useSelector(selectAllConfigLotWithCosts);

  const columns: GridColDef[] = [
    {
      field: 'lotName',
      headerName: `${translate('lot.singular')}`,
      width: 200,
    },
    {
      field: 'costOccupiedKilometre',
      headerName: `${translate('tours.tourDetail.price.occupiedCostPerKm')}`,
      valueGetter: (value: number) => nullAndUndefinedSafeCentToEuro(value),
      width: 200,
    },
    {
      field: 'costEmptyKilometre',
      headerName: `${translate('tours.tourDetail.price.emptyCostPerKm')}`,
      valueGetter: (value: number) => nullAndUndefinedSafeCentToEuro(value),
      width: 200,
    },
    {
      field: 'costFlatRate',
      headerName: `${translate('tours.tourDetail.price.costFlatRate')}`,
      valueGetter: (value: number) => nullAndUndefinedSafeCentToEuro(value),
      width: 175,
    },
    {
      field: 'costAddition',
      headerName: `${translate('tours.tourDetail.price.costAddition')}`,
      valueGetter: (value: number) => nullAndUndefinedSafeCentToEuro(value),
      width: 175,
    },
    {
      field: 'ignoreInCalculation',
      headerName: `${translate('lot.ignoreInCalculation')}`,
      valueGetter: (value: boolean) => (value ? `${translate('yes')}` : `${translate('no')}`),
      width: 175,
    },
  ];

  let content;
  if (isLoadingAllConfigLot) {
    content = <CircularProgress />;
  } else if (allConfigLotLoaded) {
    content = (
      <DataGridPro
        columns={columns}
        rows={allConfigLot}
        apiRef={apiRef}
        slots={{ toolbar: customToolbarMinimal }}
        sx={{ height: 600 }}
        localeText={setDataGridLocale()}
      />
    );
  }

  return (
    <>
      <Helmet>
        <title>{`${translate('lot.title')}`}</title>
      </Helmet>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <CustomBreadcrumbs
          heading={`${translate('config.config')} ${translate('lot.title')}`}
          links={[
            { name: `${translate('dashboard')}`, href: PATH_DASHBOARD.root },
            { name: `${translate('lot.title')}` },
          ]}
        />
        <Card>{content}</Card>
      </Container>
    </>
  );
}
